import { VaultFileDropAreaInfoWrapper, VaultFileDropAreaInfo, VaultFileDropAreaInfoContentWrapper, VaultFileDropAreaInfoIcon, VaultFileDropAreaInfoText, VaultFileDropAreaInfoData, VaultConciergeContent, VaultConciergeContentWrapper, VaultFileDropAreaInfoDataWrapper } from './VaultDropArea.styles'
import { ConciergeIcon, DocumentsTypesIcon, SecuredAiIcon } from '../../assets/icons'
import { DocumentTypesHoverEffectContent } from '../../../user-activation-flow/components/steps/VaultStep'
import { successNotification } from '../../../layout/components/Notifications/notifications'
import { VAULT_SECURE_TAG_TEXT } from '../Vault.const'

export const VaultInfo = () => {
    return (
        <VaultFileDropAreaInfoWrapper>
            <VaultInfoItem icon={<DocumentsTypesIcon />} text="Document types" element={<DocumentTypesHoverEffectContent />} />
            <VaultInfoItem icon={<ConciergeIcon />} text="Concierge" element={<ConciergeContent />} />
            <VaultInfoItem icon={<SecuredAiIcon />} text="Secured" element={<SecuredContent />} />
        </VaultFileDropAreaInfoWrapper>
    )
}

const VaultInfoItem = ({ icon, text, element }) => {
    return (
        <VaultFileDropAreaInfo>
            <VaultFileDropAreaInfoContentWrapper>
                <VaultFileDropAreaInfoIcon>
                    {icon}
                </VaultFileDropAreaInfoIcon>
                <VaultFileDropAreaInfoText>
                    {text}
                </VaultFileDropAreaInfoText>
            </VaultFileDropAreaInfoContentWrapper>
            <VaultFileDropAreaInfoDataWrapper>
                <VaultFileDropAreaInfoData>
                    {element}
                </VaultFileDropAreaInfoData>
            </VaultFileDropAreaInfoDataWrapper>
        </VaultFileDropAreaInfo>
    );
}

const ConciergeContent = () => {
    const handleCopyText = () => {
        navigator.clipboard.writeText('secure-import@vyzer.co');
        successNotification('Email copied');
    }

    return (
        <VaultConciergeContentWrapper>
            <div>Quickly and securely forward any</div>
            <div>financial document you receive</div>
            <div>via email to your Vault.</div>
            <VaultConciergeContent onClick={handleCopyText}>secure-import@vyzer.co<span><CopyIcon /></span></VaultConciergeContent>
        </VaultConciergeContentWrapper>
    )
};

const CopyIcon = () => {
    return (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3.5" y="5" width="7.5" height="9" rx="0.5" stroke="#72E1AC" />
        <path d="M6 3H12C12.5523 3 13 3.44772 13 4V11" stroke="#72E1AC" strokeLinecap="round" />
    </svg>
    )
}

const SecuredContent = () => {
    return (
        <div style={{ width: '400px' }}>
            {VAULT_SECURE_TAG_TEXT}
        </div>
    )
}